import { ThemeEvents } from '@theme/events';

class ProductMediaGallery extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  updateMediaGallery = (event) => {
    const newMediaGallery = event.detail.data.html.querySelector('product-media-gallery');
    const currentMediaGallery = this;

    if (!newMediaGallery || !currentMediaGallery) return;

    if (currentMediaGallery.innerHTML !== newMediaGallery.innerHTML) {
      currentMediaGallery.innerHTML = newMediaGallery.innerHTML;

      window.ShopifyXR?.setupXRElements();
    }
  };
}

if (!customElements.get('product-media-gallery')) {
  customElements.define('product-media-gallery', ProductMediaGallery);
}
